import _ from 'lodash'
import { useContext, useState } from 'react'
import { Icon, Label } from 'semantic-ui-react'
import { uniqueKey } from '../../../global/common/keys'
import Checker from '../../../global/components/forms/elements/Checker'
import { appUserLevels } from '../../../global/enums/globalEnums'
import { GolfParentContext } from '../cnr/contexts/GolfParentContext'
import GolferChange from './GolferChange'
import GolferHandicap from './GolferHandicap'
import GolferHandicapLabelGroup from './GolferHandicapLabelGroup'
import { golferTournamentHeaderModes, golfersModes } from './Golfers'
import { useGolfers } from '../useHelpers/useGolfers'

export const handicapModes = {
  event: 'event',
  match: 'match',
  teamMatch: 'teamMatch',
  tournament: 'tournament',
  none: 'none'
}

export const golferRowTypes = {
  single: 'single',
  team: 'team',
}

export const handicapRowModes = {
  courseHandicap: 'courseHandicap',
  handicapSource: 'handicapSource',
  handicapDays: 'handicapDays',
  handicapIndex: 'handicapIndex',
  matchHandicap: 'matchHandicap',
  matchHandicap_alt: 'matchHandicap_alt',
  matchHandicap_alt_perc: 'matchHandicap_alt_perc',
  matchHandicap_bb_perc: 'matchHandicap_bb_perc',
  tournamentHandicapIndex: 'tournamentHandicapIndex',
  teebox: 'teebox',
  ave: 'ave',
  altShot: 'altShot',
  sum: 'sum',
  recommendedCourseHandicap: 'recommendedCourseHandicap',
  recommendedTeeBox: 'recommendedTeeBox'
}

const GolferRow = (props) => {

  const { golfer, golferRowType, golferHeaderMode, golfersMode, index, handicapMode, handleClick, roundType } = props

  const { get_golferHandicaps } = useGolfers()

  const {
    key: key_golfer,
    _authData,
    teamNumber,
    lastName,
    firstName,
    allowLineupModification,
  } = golfer

  const { key, _itemKey } = golfer

  const keyy = _itemKey ? _itemKey : key

  const _handicaps = get_golferHandicaps({ golfer })

  // golfParentContext 
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states, fns, handlers } = golfParent_contexts ?? {}
  const { paps_state, golfTournament_state, golfEvent_state } = states ?? {}
  const { appUser_fns } = fns ?? {}
  const { golfers: golfers_event } = golfEvent_state ?? {}
  const { checkedGolfer, golferRecords, golfStyles } = golfTournament_state ?? {}
  const { pathViews } = paps_state ?? {}
  const { golfTournament_handlers } = handlers ?? {}
  const { roundColors } = golfStyles ?? {}

  const _g = golfers_event ? _.merge(golfer, golfers_event?.[key_golfer]) : {}

  const allowMods = appUser_fns ? appUser_fns.validateAccess_item(appUserLevels.superAdmin, true) : false

  // local state
  const [currentGolferHcp, setCurrentGolferHcp] = useState()
  const [currentGolferEdit, setCurrentGolferEdit] = useState()
  const [currentChangeGolfer, setCurrentChangeGolfer] = useState()

  let allowCourseHandicapChange;

  const allowGolferChange = pathViews.golfTournaments ? true : false

  if (pathViews.golfTournaments && _handicaps.tournamentHandicapIndex) {
    allowCourseHandicapChange = true
  }

  const handleShowHandicap = (e, allowClick, handicapRowMode) => {
    if (allowMods) {
      e.stopPropagation()
      if (allowClick) {
        setCurrentGolferHcp({ golfer, handicapRowMode })
      }
    }
  }

  const handleShowChangeGolfer = (e, allowClick) => {
    if (allowMods) {
      e.stopPropagation()
      if (allowClick) {
        setCurrentChangeGolfer(golfer)
      }
    }
  }

  const handleShowEdit = (e, allowClick) => {
    if (allowMods) {
      e.stopPropagation()
      if (allowClick) {
        setCurrentGolferEdit({ golfer, handicapRowMode: handicapRowModes.handicapIndex })
      }
    }
  }

  const handleCancelHandicap = () => setCurrentGolferHcp()
  const handleCancelEdit = () => setCurrentGolferEdit()

  const handleCancelChange = () => setCurrentChangeGolfer()

  const hcpLabelGroup = () => <GolferHandicapLabelGroup
    keyy={keyy}
    _handicaps={_handicaps}
    handicapMode={handicapMode}
    allowCourseHandicapChange={allowCourseHandicapChange}
    handleShowHandicap={handleShowHandicap}
    roundType={roundType}
  />

  const golferIcon = (alm) => {
    const iconProps = {
      name: 'user',
      color: 'grey',
      size: 'large',
      title: ''
    }

    if (_authData) {
      const { isRecent, lastRefreshTime } = _authData ?? {}
      iconProps.title = lastRefreshTime
      iconProps.color = 'blue';
      iconProps.name = 'user circle'
      if (isRecent) {
        iconProps.color = 'green'
      }
    } else {
      iconProps.name = 'user circle outline'
      iconProps.color = alm ? 'orange' : 'grey'
    }

    if (allowMods && (_g?.phoneNumber || _g?.email)) {
      let icon = 'mail'
      if (_g?.phoneNumber) { icon = 'phone' }
      return <Icon.Group>
        <Icon {...iconProps} onClick={(e) => { allowMods && handleShowEdit(e, golfer) }} />
        <Icon corner name={icon} color='black' />
      </Icon.Group>
    } else {
      return <Icon {...iconProps} onClick={(e) => { allowMods && handleShowEdit(e, golfer) }} />
    }

  }

  const golferItem_record = (golferRecord) => {
    const { wins, losses, ties, points, holes } = golferRecord
    const { wins: wins_hole, losses: losses_hole, ties: ties_hole } = holes
    return <Label.Group size='mini' key={uniqueKey('glfr', keyy, index, 0)} className={'golfer-record'} >
      <Label className='glf-p' color='blue'>{'Points: '}{points}</Label>
      <Label className='glf-w' color='green'>{'Wins: '}{wins}</Label>
      <Label className='glf-t' color='grey'>{'Ties: '}{ties}</Label>
      <Label className='glf-l' color='red'>{'Losses: '}{losses}</Label>
      <Label className='glf-hw' color='green'>{'HW: '}{wins_hole}</Label>
      <Label className='glf-ht' color='grey'>{'HT: '}{ties_hole}</Label>
      <Label className='glf-hl' color='red'>{'HL: '}{losses_hole}</Label>
    </Label.Group >
  }

  const golferItem_opponent = (golferRecord) => {
    const { opponents } = golferRecord
    const divs = []
    if (opponents) {
      _.forEach(opponents, (opponent) => {
        const { firstName, lastName, tournamentHandicapIndex, matchStatuses } = opponent
        _.forEach(matchStatuses, (matchStatus) => {
          const { finalScore, round, won, tied } = matchStatus
          const roundStyle = { backgroundColor: roundColors[round], color: 'black' }
          let resultColor = won ? 'green' : 'red'
          if (tied) { resultColor = 'grey' }
          divs.push(
            <div className='golfer-opp'>
              <div>{firstName}{' '}{lastName}{' ('}{tournamentHandicapIndex}{')'}</div>
              <Label style={roundStyle}>{_.startCase(round)}</Label>
              <Label color={resultColor}>{finalScore}</Label>
            </div>
          )
        })
      })
    }
    return <div className='golfer-opps'>
      {divs}
    </div>
  }

  const golferItem_partners = (golferRecord) => {
    const { partners } = golferRecord ?? {}
    const divs = []
    _.forEach(partners, (partner, pk) => {
      const { lastName, firstName } = partner
      divs.push(
        <div className='golfer-part'>
          <div>{firstName}{' '}{lastName}</div>
          <div>A</div>
          <div>B</div>
          {/* <Label style={roundStyle}>{_.startCase(round)}</Label>
          <Label color={resultColor}>{finalScore}</Label> */}
        </div>
      )
    })
    return <div className='golfer-part'>
      {divs}
    </div>
  }

  const golferItem_single = () => {
    let cn = 'golfer-row'
    if (golferHeaderMode === golferTournamentHeaderModes.records) { cn += ' rcd' }
    if (golferHeaderMode === golferTournamentHeaderModes.opponents) { cn += ' opp' }
    if (golferHeaderMode === golferTournamentHeaderModes.partners) { cn += ' part' }
    return <div key={uniqueKey('glf', keyy, index, 0)} className={cn} onClick={(e) => { handleClick && handleClick(golfer) }}>
      <div key={uniqueKey('glf', keyy, index, 1)} className={'golfer-index'}><Label size='mini' onClick={(e) => { allowMods && handleShowChangeGolfer(e, allowGolferChange) }} color={'grey'}>{index + 1}</Label></div>
      <div key={uniqueKey('glf', keyy, index, 2)} className={'golfer-icon'}>{golferIcon(allowLineupModification)}</div>
      <div key={uniqueKey('glf', keyy, index, 4)} className={'golfer-name'}>{lastName}{', '}{firstName} </div>
      {golferHeaderMode === golferTournamentHeaderModes.handicaps && hcpLabelGroup()}
      {golferRecords && golferRecords[keyy] && golferHeaderMode === golferTournamentHeaderModes.records && golferItem_record(golferRecords[keyy])}
      {golferRecords && golferRecords[keyy] && golferHeaderMode === golferTournamentHeaderModes.opponents && golferItem_opponent(golferRecords[keyy])}
      {golferRecords && golferRecords[keyy] && golferHeaderMode === golferTournamentHeaderModes.partners && golferItem_partners(golferRecords[keyy])}
    </div >
  }

  const golferItem_change = () => {
    const keyy = _itemKey ? _itemKey : key
    return <div key={uniqueKey('glf', keyy, index, 0)} className={'golfer-row'} >
      <div key={uniqueKey('glf', keyy, index, 1)} className={'golfer-index'}> <Checker item={golfer} handle_click={golfTournament_handlers.handleCheck_eventGolfer} checked={checkedGolfer === golfer._itemKey} /></div>
      <div key={uniqueKey('glf', keyy, index, 2)} className={'golfer-icon'}><Icon name='user' size='large' /></div>
      <div key={uniqueKey('glf', keyy, index, 4)} className={'golfer-name'}>{lastName}{', '}{firstName}</div>
      {hcpLabelGroup()}
    </div >
  }

  const golferItem = () => lastName + ', ' + firstName

  const golferItem_team = (isTeam1) => {
    let cn = 'golfer-row golfer-team'
    if (!_handicaps.courseHandicap) { cn += ' ns' }
    return <div className={cn} key={key_golfer} onClick={(e) => { handleClick(key_golfer) }}>
      <div key={uniqueKey('gt', 2, 'd1')} className={'golfer-details-1'}>{isTeam1 && golferItem()}</div>
      {hcpLabelGroup()}
      <div key={uniqueKey('gt', 2, 'd3')} className={'golfer-details-2'}>{!isTeam1 && golferItem()}</div>
    </div >
  }

  if (currentGolferHcp) {
    return <GolferHandicap
      currentGolferHcp={currentGolferHcp}
      golfer={currentGolferHcp.golfer}
      handicapRowMode={currentGolferHcp.handicapRowMode}
      handicapMode={handicapMode}
      showTeebox={true}
      handleCancel={handleCancelHandicap} />
  } else if (currentGolferEdit) {
    return <GolferHandicap
      currentGolferHcp={currentGolferEdit}
      golfer={currentGolferEdit.golfer}
      handicapRowMode={handicapRowModes.handicapIndex}
      handicapMode={handicapMode}
      showTeebox={true}
      handleCancel={handleCancelEdit} />
  } else if (currentChangeGolfer) {
    return <GolferChange
      golfer={currentChangeGolfer}
      handleCancel={handleCancelChange} />
  } else {
    console.log('golferRowType', golferRowType)
    switch (golferRowType) {
      case golferRowTypes.single:
        if (golfersMode === golfersModes.tournamentChange) {
          return golferItem_change()
        } else {
          return golferItem_single()
        }
      case golferRowTypes.team:
        switch (teamNumber) {
          case 1:
            return golferItem_team(true)
          default:
            return golferItem_team(false)
        }
      default:
        if (golfersMode === golfersModes.tournamentChange) {
          return golferItem_change()
        } else {
          return golferItem_single()
        }
    }
  }
}

export default GolferRow